export class UserError {
  readonly message: string;
  readonly code = 'USER_ERROR';

  constructor(message: string) {
    this.message = message;
  }
}
